function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b91628f7-a778-4c5d-a3ab-41fb39f699ba",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "aa7fa076-d5ec-4813-a658-53dfaa466a91",
    "data-name": "Wave-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bd88f524-d07b-4337-a2ff-b8493fe2deb6",
    "data-name": "Rectangle-Copy-6",
    d: "M0,48H1366v-.029C1161,47.971,657,0,0,0Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  })));
}

export default SvgWave11;